import React from 'react';
import { Grid, Dropdown, Button } from 'semantic-ui-react';
import $ from "jquery";
import { Link } from "react-router-dom";
import firebase from 'firebase';

import Title from '../../title';
import Server from '../../../functions/server';
import Loading from '../../loading';
import Orders from './order';
import ReadCookie from '../../../functions/readcookies';
import Customerdetails from '../../others/customerdetails';
import OrderStatus from '../orderstatus';
import Permission from '../../../functions/permission';
import Release from '../../../functions/release';

class Order extends React.Component {

  state = {
    customerOption: [], customer: '', customers: [],
    allbranch: [], paymentmode: [], allowtoorder: 0, menuPermission: []
  }

  componentDidMount() {
    this.menuControl();
    this.getPaymentMode();
  }
  
  menuControl() {
    let menuPermission = Permission('place-order', this.props.menus);
    this.setState({ menuPermission })
    this.getCustomerType();
  }

  getCustomerType() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Customers' })
    $.ajax({
      type: 'POST', data: { 'userId': userId },
      url: Server() + 'customer/getallcustomers.php',
      success: function(data) {
        console.log(data);
        console.log('data data data');
        try {
          data = JSON.parse(data);
          context.setAllCustomerType(data);
        } catch (e) { console.log(e); context.setState({ load: false }); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  setAllCustomerType(data) {
    let branchId, branchState;
    let datas = (ReadCookie("branch"));
    if (datas == 0) {
      this.setState({ permissionError: 'You not have permission to access this menu!!!' })
    }
    else {
      for (var i = 0; i < data.length; i++) {
        branchId = data[i].branch_id;
        branchState = data[i].state;
      }
    }
    let context = this; var customer = [];
    data.map((y) => {
      let text = y.id+"->"+y.name+"->"+y.machine_no+"->"+y.taluk+"->"+y.mobile+"->"+y.alt_mobile+'->'+y.emp_id;
      customer.push({key: text, text: text, value: text});
    });
    this.setState({ customerOption: customer, customers: data, load: false, branch: branchId, branchState: branchState });
  }

  getPaymentMode() {
    let context = this;
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Paymentmode' })
    $.ajax({
      type: 'POST',
      data: { 'executiveid': userId, branchId },
      url: Server() + 'modecontrol/getmode.php',
      success: function(data) {
        console.log(data);
        console.log('mode error');
        try {
          data = JSON.parse(data);
          context.setState({ paymentmode: data, load: false })
        } catch (e) { context.setState({ load: false }); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  customer = event => {
    let value = event.target.value;
    let dropdown =  event.target.value;
    let data = this.state.customers;
    let customerPoints = 0;
    let allowtoorder = 0;
    let customerId;
    let executiveId = value.split('->')[5];
    value = value.split('->')[0];
    let customerState, customerName;
    for (var i = 0; i < data.length; i++) {
      if (data[i].id == value) {
        allowtoorder = 1;
        customerName = data[i].name; customerId=data[i].id; customerState = data[i].state; customerPoints = data[i].points;
        this.setState({ allowtoorder })
      }
    }
    this.setState({ allowtoorder, customer: value, customerName, customerState, dropdown, customerPoints, executiveId });
  }

  selectedCustomer = (f, { value }) => {
    if (this.state.menuPermission.add) {
      let data = this.state.customers;
      let customerTCS = 0;
      let executiveId = value.split('->')[5];
      value = value.split('->')[0];
      let customerState, customerName, customerPoints;
      for (var i = 0; i < data.length; i++) {
        if (data[i].id == value) {
          customerTCS = data[i].tcs; customerName = data[i].name; customerState = data[i].state; customerPoints = data[i].points;
        }
      }
      this.setState({ customer: value, customerName, customerTCS, customerState, customerPoints, executiveId });
    }
    else {
      alert('You Are Not Allow To Add Place Order!!!')
    }
  }

  render() {
    let customerDetails = (<div></div>);
    if (this.state.customer.length >= 1) {
      customerDetails = (<Customerdetails customerName={this.state.customerName} customerId={this.state.customer} />)
    }
    return (
      <div style={{display: this.state.placeorderview}}>
        <Title title={'Place Order'} openDrawer={this.props.openDrawer} />
        { this.state.menuPermission.view ?
          (
            <div>
              <Loading load={this.state.load} message={this.state.message} />
              <div style={{padding: '0.5%', display: this.state.placeorderedit}}>
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={6}>
                    <br/>
                    <Dropdown placeholder='Select Customer' style={{width: '100%'}} onChange={this.selectedCustomer}
                    search selection options={this.state.customerOption} />
                    {customerDetails}
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    { this.state.customer ?
                      (
                        <Orders customer={this.state.customer} branch={this.state.branch}
                          customerTCS={this.state.customerTCS}
                          customerName={this.state.customerName} viewEdit={this.state.viewEdit}
                          branchState={this.state.branchState} executiveId={this.state.executiveId}
                          customerPoints={this.state.customerPoints} paymentmode={this.state.paymentmode}
                          customerState={this.state.customerState} customers={this.state.customerOption} />
                      ):''
                    }
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={2}>
                    <br/>
                    <Link to={"/"+Release()+"/add-customer"}><Button primary>Add Customer</Button></Link>
                  </Grid.Column>
                </Grid>
              </div>
              <OrderStatus customer={this.state.customer} menuPermission={this.state.menuPermission}  placeorderedit={this.state.placeorderedit} />
              <center style={{color: 'red'}}><b>{this.state.permissionError}</b></center>
            </div>
          ):
          ( <div><center>You are not allow to access this menu!!!</center></div> )
        }
      </div>
    );
  }
}

export default Order;
